<template>
  <v-dialog
    v-model="dialog_ativo"
    content-class="bar-12"
    width="1400px"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card id="bloco-conteudo">
      <div class="text-center">
        <BaixarCotacao />

        <p id="decricao" v-text="'Cotações baixadas com sucesso!'" />

        <SysBotao
          id="botao-fechar"
          background="#142454"
          color-texto="white"
          :radius="8"
          v-text="'Fechar'"
          @click="fechar"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import SysBotao from "../../../../utils/botoes/SysBotao";
import VisibilidadeCarrinhoCompraComputed from "../VisibilidadeCarrinhoCompraComputed";
import BaixarCotacao from "../../../../utils/icones/BaixarCotacao";

export default {
  name: "CotacoesBaixadasComSucesso",
  mixins: [VisibilidadeCarrinhoCompraComputed],
  components: {
    SysBotao,
    BaixarCotacao
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dialog_ativo: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  },
  methods: {
    fechar() {
      this.dialog_ativo = false;
      this.visibilidade_carrinho_compra = false;
    }
  }
}
</script>

<style scoped>
#bloco-conteudo {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
#decricao {
  font-size: 24px;
  color: #142454;
  line-height: 24px;
  margin: 16px 0;
}
#botao-fechar {
  margin: 16px 0;
}
</style>
